import * as React from 'react';
import './index.css';
import { ImgOverlay } from '@components/HomePage/common/interface';

interface Props {
  shopStatus: any;
  imgOverlay: ImgOverlay;
  isSmallCard?: boolean; //小图商卡
  customBorderRadius?: number; // 自定义圆边
}

export default class ImgOverlayView extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { shopStatus, imgOverlay } = this.props;
    return imgOverlay ? this.renderViewByImgOverlay(imgOverlay) : this.renderViewByShopStatus(shopStatus);
  }

  renderViewByImgOverlay(imgOverlay) {
    const { isSmallCard, customBorderRadius = 0 } = this.props;
    return (
      <view
        className="restBg"
        style={{
          backgroundColor: imgOverlay.bgColor || 'transparent',
          borderRadius: customBorderRadius
        }}
      >
        {imgOverlay?.title && (
          <view className="rest-text-con">
            <text
              className="restTitle" content={imgOverlay?.title} style={{
                color: imgOverlay.textColor
              }}
            />
          </view>
        )}
        {imgOverlay?.subTitle && (
          <view className="rest-text-con" style={{ marginTop: isSmallCard ? 2 : 4 }}>
            <text
              className="restTitle" content={imgOverlay.subTitle} style={{
                color: imgOverlay.textColor
              }}
            />
          </view>
        )}
      </view>
    );
  }

  renderViewByShopStatus(shopStatus) {
    const { isSmallCard, customBorderRadius = 0 } = this.props;
    return (
      <view className="restBg" style={{ borderRadius: customBorderRadius }}>
        {shopStatus.shopStatusDesc && (
          <view className="rest-text-con">
            <text className="restTitle" content={shopStatus.shopStatusDesc} />
          </view>
        )}
        {shopStatus.nextBusinessHour && (
          <view className="rest-text-con" style={{ marginTop: isSmallCard ? 2 : 4 }}>
            <text className="restTitle" content={shopStatus.nextBusinessHour} />
          </view>
        )}
      </view>
    );
  }
}
